<template>
    <brick-octagon-base>
        <template #icon>
            <brick-icon :brick-type="brickType" />
        </template>
        
        <template #content-bottom>
            <div class="brick-title">
                {{displayName}}
            </div>
        </template>
    </brick-octagon-base>
</template>

<script>
    import BrickOctagonBase from "@modules/JourneyBuilder/Components/Patterns/BrickOctagonBase.vue";
    import BrickIcon from "@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickIcon";

    export default {
        name: 'menu-composable-octagon-bricks',
        components: {
            BrickOctagonBase,
            BrickIcon
        },
        props: {
            displayName: {
                type: String,
                required: true
            },
            brickType: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/composable-octagon-brick.scss";
</style>
